export const PASSWORD_MANAGEMENT = {
  PASSWORD_FORM: {
    HEADER: {
      TITLE: 'Change Password',
      SUBTITLE:
        'Please enter your current password and choose a new secure password',
      ACCOUNT_NOTE: "You're updating the password for this account",
    },

    PASSWORD_REQUIREMENTS: {
      TITLE: 'Password Requirements:',
      LENGTH: 'At least 12 characters long',
      LOWERCASE: 'Include at least one lowercase letter (a-z)',
      UPPERCASE: 'Include at least one uppercase letter (A-Z)',
      NUMBER: 'Include at least one numeric digit (0-9)',
      SPECIAL: 'Include at least one special character (!@#$%^&*)',
    },

    LABELS: {
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_PASSWORD: 'Confirm Password',
    },
    ERROR: {
      oldPassword: {
        required: 'Old password is required',
      },
      newPassword: {
        required: 'New password is required',
        passwordSameAsOld:
          'New password should not be the same as the old password',
        weakPassword:
          'Password must be at least 12 characters long, include an uppercase letter, a number, and a special character.',
      },
      confirmPassword: {
        required: 'Confirm password is required',
        mustMatch: 'Confirm password must match new password',
      },
    },
    PLACEHOLDERS: {
      CURRENT_PASSWORD: 'Enter your current password',
      NEW_PASSWORD: 'Enter a new password',
      CONFIRM_PASSWORD: 'Re-enter the new password',
    },
    BUTTONS: {
      CHANGE_PASSWORD: 'Change Password',
      LOADING_TEXT: 'Changing Password...',
    },
    TOAST_MESSAGE: {
      SUCCESS: 'Password changed successfully. Please log in again.',
      ERROR:
        'An error occurred while processing your request. Please contact support@growth99.com for assistance.',
    },
  },
};
